import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type MaintenanceState = {
  active: boolean;
  message?: string;
  title?: string;
};

const initialState: MaintenanceState = {
  active: false,
  message: undefined,
  title: undefined
}

const maintenanceSlice = createSlice({
  name: 'maintenance',
  initialState,
  reducers: {
    maintenanceStarted (state, action: PayloadAction<MaintenanceState>) {
      state.active = true
      state.message = action.payload.message
      state.title = action.payload.title
    },
    maintenanceEnded (state) {
      state.active = false
      state.message = undefined
      state.title = undefined
    }
  }
})

export const { maintenanceStarted, maintenanceEnded } = maintenanceSlice.actions
export default maintenanceSlice.reducer
